import { useMemo } from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';

interface SourceLocation {
  sourceUrl: string | undefined;
  host: string | undefined;
  projectSlug: string | undefined;
  projectUrl: string | undefined;
}

export function useSourceLocation(): SourceLocation {
  const { entity } = useEntity();
  const raw = entity.metadata.annotations?.['backstage.io/source-location'];

  return useMemo(() => {
    const empty: SourceLocation = { sourceUrl: undefined, host: undefined, projectSlug: undefined, projectUrl: undefined };
    if (!raw) return empty;

    const sourceUrl = raw.replace(/^url:/, '');

    try {
      const parsed = new URL(sourceUrl);
      const match = parsed.pathname.match(/^\/(.+?)\/-\//);
      if (!match) return { ...empty, sourceUrl };

      const host = parsed.host;
      const projectSlug = match[1];
      const projectUrl = `${parsed.origin}/${projectSlug}`;

      return { sourceUrl, host, projectSlug, projectUrl };
    } catch {
      return { ...empty, sourceUrl };
    }
  }, [raw]);
}
